import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statCompanyStockLocaleModule: LocaleModule = {
  name: "statCompanyStock",
  messages: { en: en, it: it },
};
